import msalInstance, { loginRequest } from "../helpers/authProvider";
import { AccountInfo, AuthenticationResult } from "@azure/msal-browser";

async function getToken(): Promise<AuthenticationResult>
{
    const accountInfoStr = localStorage.getItem('accountInfo');
    if (!accountInfoStr) {
        throw new Error("No account info found");
    }
    
    const accountInfo: AccountInfo = JSON.parse(accountInfoStr);
    
    let account = msalInstance.getAccountByUsername(accountInfo.username || '') 
                  || msalInstance.getAccountByHomeId(accountInfo.homeAccountId || '');
    

    if (!account) {
        const allAccounts = msalInstance.getAllAccounts();
        account = allAccounts.find(acc => 
            acc.username === accountInfo.username || 
            acc.homeAccountId === accountInfo.homeAccountId
        ) || accountInfo;
    }

    return msalInstance.acquireTokenSilent({
                scopes: loginRequest.scopes,
                account: account,
                forceRefresh: true
    });

}

export default async function callApi(method: string, URI: string, body: any = null, count: number = 2) {
    const tkn = localStorage.getItem('tkn');
    const url = `${process.env.REACT_APP_API}/${URI}`;

    let myHeaders =  new Headers(
        {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${tkn}`,
        }
    );

    let configCall: RequestInit = {
        method,
        headers: myHeaders,
    };

    if (method !== 'GET') {
        configCall.body = JSON.stringify(body)
    }

    try {
        let r = await fetch(url, configCall);
        if (!r.ok) {
            if (r.status === 401) {
                //localStorage.clear();
                //window.location.pathname = '/';
                while(count>=0)
                {
                    count=-1;

                    let tokenResult = await getToken();

                    localStorage.setItem('tkn', tokenResult.accessToken);

                    let myHeaders =  new Headers(
                        {
                            'Content-Type': 'application/json',
                            'Authorization': `Bearer ${tokenResult.accessToken}`,
                        }
                    );

                    let configCall: RequestInit = {
                        method,
                        headers: myHeaders,
                    };

                    if (method !== 'GET') {
                        configCall.body = JSON.stringify(body)
                    }

                    r = await fetch(url, configCall);

                    if(r.ok)
                    {
                        if(r.status ===204) return;

                        return await r.json();
                    }

                    if(!(!r.ok && r.status === 401))
                        break;

                }
            }

            const errResponse = await r.json();
            throw errResponse;
        }
        else {
            if (r.status === 204) return;

            return await r.json();
        }
    } catch (err_1) {
        throw err_1;
    }
}

export async function callApiBlob(method: string, URI: string, body: any = null) {
    const tkn = localStorage.getItem('tkn');
    const url = `${process.env.REACT_APP_API}/${URI}`;

    let myHeaders =  new Headers(
        {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${tkn}`,
        }
    );

    let configCall: any = {
        method,
        headers: myHeaders,
        responseType: 'blob'
    };

    if (method !== 'GET') {
        configCall.body = JSON.stringify(body)
    }

    try {
        const r = await fetch(url, configCall);
        if (!r.ok) {
            if (r.status === 401) {
                localStorage.clear();
                window.location.pathname = '/';
            }

            const errResponse = await r.json();
            throw errResponse;
        }
        else {
            if (r.status === 204) return;

            return await r.blob();
        }
    } catch (err_1) {
        throw err_1;
    }
}

export async function callApiFile(method: string, URI: string, file: File | File[], json: any = undefined) {
    const tkn = localStorage.getItem('tkn');
    const url = `${process.env.REACT_APP_API}/${URI}`;

    let myHeaders =  new Headers(
        {
            'Authorization': `Bearer ${tkn}`,
        }
    );

    let configCall: RequestInit = { 
        method,
        headers: myHeaders,
    };
    
    var data = new FormData();
    if(Array.isArray(file)) {
        file.forEach(file => {
            data.append('files', file);
        })
    } else {
        data.append('file', file);
    }

    if(json)
        data.append('json', JSON.stringify(json));

    configCall.body = data

    try {
        const r = await fetch(url, configCall);
        if (!r.ok) {      
            if (r.status === 401) {
                localStorage.clear();
                window.location.pathname = '/';
            }

            const errResponse = await r.json();
            throw errResponse;
        }
        else {
            if (r.status === 204) return;
            
            return await r.json();
        }
    } catch (err_1) {
        throw err_1;
    }
}

export interface BaseResponse {
    error?: string,
    errorPT?: string,
    errorES?: string,
    errorEN?: string,    
    success: boolean
}

export interface BaseResponseDto<T> {
    data: T,
    error?: string,
    errorPT?: string,
    errorES?: string,
    errorEN?: string,
    success: boolean,
    errors?: string[]
}

export interface BaseResponsePagedDto<T> {
    data: T,
    error?: string,
    errorPT?: string,
    errorES?: string,
    errorEN?: string,
    success: boolean,
    totalPages: number,
    totalItems: number,
    currentTake: number
}

export interface UniToken {
    idp: string,
    sub: string,
    name: string,
    tfp: string,
    azp: string,
    ver: string,
    iat: Number,
    aud: string,
    exp: Number,
    iss: string,
    nbf: Number,
    extension_Profile: string,
}